import { motion } from "framer-motion";
import aboutimage from "../Assets/Images/aboutusimage.jpg"; // Replace with your image path

const AboutUs = () => {
  return (
    <div className="bg-black text-white py-12 px-6 md:px-16">
      <div className="container mx-auto flex flex-col md:flex-row items-center gap-12">
        {/* Left Side - Image */}
        <motion.div
          className="md:w-1/2 w-full"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: false, amount: 0.3 }}
        >
          <img
            src={aboutimage}
            className="rounded-lg shadow-lg border-4 border-gray-700 w-full h-auto object-cover"
            alt="About Us"
          />
        </motion.div>

        {/* Right Side - Text */}
        <motion.div
          className="md:w-1/2 w-full"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
          viewport={{ once: false, amount: 0.3 }}
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4">About Us</h2>
          <p className="text-gray-400 text-lg mb-6">
            Welcome to our space of innovation and excellence. We are committed to delivering top-notch solutions that empower businesses and individuals to achieve their goals. With a focus on creativity, technology, and customer satisfaction, we strive to make a difference in the industry.
          </p>
          <p className="text-gray-400 text-lg mb-6">
            Our team of experts brings years of experience in various fields, ensuring that every project we undertake is executed with precision and dedication. Whether it's cutting-edge technology, strategic consulting, or customized solutions, we have the expertise to bring your vision to life.
          </p>
          <p className="text-gray-400 text-lg mb-6">
            We believe in building strong relationships with our clients, understanding their needs, and providing solutions that drive success. Our approach is centered on innovation, adaptability, and continuous improvement to stay ahead in a fast-evolving world.
          </p>
          <p className="text-gray-400 text-lg mb-6">
            Join us on this journey of growth and transformation. Let's collaborate to create impactful solutions that make a difference. Explore our services and discover how we can help you achieve your ambitions.
          </p>

          <motion.a
            href="/about"
            className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 rounded-full text-lg font-semibold inline-block"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Read More
          </motion.a>
        </motion.div>
      </div>
    </div>
  );
};

export default AboutUs;
